// Axios 封装
import axios from 'axios'
import { API_CONFIG } from '@/utils/constants'
import { Message } from 'ant-design-vue'

// 创建 Axios 实例
const service = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加 API Key
    if (config.headers) {
      config.headers['api-key'] = API_CONFIG.API_KEY
    }

    // 可以在这里添加 token 等认证信息
    // const token = store.getters.token
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`
    // }

    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 根据实际 API 响应结构处理
    // 如果 API 返回的数据结构是 { code, data, message }
    if (res.code !== undefined) {
      if (res.code === 200 || res.code === 0) {
        return res.data || res
      } else {
        Message.error(res.message || '请求失败')
        return Promise.reject(new Error(res.message || '请求失败'))
      }
    }

    // 如果 API 直接返回数据
    return res
  },
  error => {
    console.error('Response error:', error)

    let message = '请求失败，请稍后重试'

    if (error.response) {
      // 服务器返回了错误状态码
      const {
        status,
        data
      } = error.response

      switch (status) {
        case 400:
          message = data?.message || '请求参数错误'
          break
        case 401:
          message = '未授权，请重新登录'
          // 可以在这里处理登录跳转
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        case 504:
          message = '网关超时'
          break
        default:
          message = data?.message || `请求失败 (${status})`
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      message = '网络错误，请检查网络连接'
    } else {
      // 发送请求时出了点问题
      message = error.message || '请求失败'
    }

    Message.error(message)
    return Promise.reject(error)
  }
)

export default service

